import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";

/* globals document, window */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { styled, StyleSheet } from '@rexlabs/styling';
import { compareParentNodes, getElementOffset, getClientPos, clamp, isCropValid, inverseOrd, containCrop } from './utils'; // Feature detection
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Improving_scrolling_performance_with_passive_listeners

var passiveSupported = false;

try {
  window.addEventListener('test', null, _Object$defineProperty({}, 'passive', {
    get: function get() {
      passiveSupported = true;
      return true;
    }
  }));
} catch (err) {} // eslint-disable-line no-empty


var xOrds = ['e', 'w'];
var yOrds = ['n', 's'];
var xyOrds = ['nw', 'ne', 'se', 'sw'];
var defaultCrop = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};
var arrowKey = {
  left: 37,
  up: 38,
  right: 39,
  down: 40
};
var nudgeStep = 0.2;
var dragBarSize = 6;
var dragHandleWidth = 9;
var dragHandleHeight = 9;
var defaultStyles = StyleSheet({
  container: {
    position: 'relative',
    display: 'inline-block',
    cursor: 'crosshair',
    overflow: 'hidden',
    maxWidth: '100%',
    backgroundColor: '#000',
    '&:focus': {
      outline: 'none'
    }
  },
  fixedAspect: {
    display: 'none'
  },
  invisible: {
    opacity: '0.5'
  },
  disabled: {
    cursor: 'inherit'
  },
  drawSurface: {
    display: 'block',
    height: '100%',
    width: '100%'
  },
  cropSelection: {
    position: 'absolute',
    top: '0',
    left: '0',
    transform: 'translate3d(0, 0, 0)',
    boxSizing: 'border-box',
    cursor: 'move',
    boxShadow: '0 0 0 9999em rgba(0, 0, 0, 0.5)',
    border: '1px solid',
    borderImageSource: "url('data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==')",
    borderImageSlice: '1',
    borderImageRepeat: 'repeat'
  },
  dragBar: {
    position: 'absolute'
  },
  ordNBar: {
    top: '0',
    left: '0',
    width: '100%',
    height: "".concat(dragBarSize, "px"),
    marginTop: '-3px'
  },
  ordEBar: {
    top: '0',
    right: '0',
    width: "".concat(dragBarSize, "px"),
    height: '100%',
    marginTop: '-3px'
  },
  ordSBar: {
    bottom: '0',
    left: '0',
    width: '100%',
    height: "".concat(dragBarSize, "px"),
    marginTop: '-3px'
  },
  ordWBar: {
    top: '0',
    left: '0',
    width: "".concat(dragBarSize, "px"),
    height: '100%',
    marginTop: '-3px'
  },
  dragHandle: {
    position: 'absolute',
    width: "".concat(dragHandleWidth, "px"),
    height: "".concat(dragHandleHeight, "px"),
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.7)',
    boxSizing: 'border-box',
    outline: '1px solid transparent'
  },
  ordNW: {
    top: '0',
    left: '0',
    marginTop: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginLeft: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'nw-resize'
  },
  ordN: {
    top: '0',
    left: '50%',
    marginTop: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginLeft: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'n-resize'
  },
  ordNE: {
    top: '0',
    right: '0',
    marginTop: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginRight: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'ne-resize'
  },
  ordE: {
    top: '50%',
    right: '0',
    marginTop: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginRight: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'e-resize'
  },
  ordSE: {
    bottom: '0',
    right: '0',
    marginBottom: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginRight: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'se-resize'
  },
  ordS: {
    bottom: '0',
    left: '50%',
    marginBottom: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginLeft: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 's-resize'
  },
  ordSW: {
    bottom: '0',
    left: '0',
    marginBottom: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginLeft: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'sw-resize'
  },
  ordW: {
    top: '50%',
    left: '0',
    marginTop: "-".concat(Math.ceil(dragHandleHeight / 2), "px"),
    marginLeft: "-".concat(Math.ceil(dragHandleWidth / 2), "px"),
    cursor: 'w-resize'
  }
});
var CropSelector = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp = _class2 = /*#__PURE__*/function (_PureComponent) {
  _inherits(CropSelector, _PureComponent);

  var _super = _createSuper(CropSelector);

  function CropSelector() {
    var _context;

    var _this;

    _classCallCheck(this, CropSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "mouseDownOnCrop", false);

    _defineProperty(_assertThisInitialized(_this), "isDragging", false);

    _defineProperty(_assertThisInitialized(_this), "containerRef", undefined);

    _defineProperty(_assertThisInitialized(_this), "drawSurfaceRef", undefined);

    return _this;
  }

  _createClass(CropSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var options = passiveSupported ? {
        passive: false
      } : false;
      document.addEventListener('mousemove', this.onDocMouseTouchMove, options);
      document.addEventListener('touchmove', this.onDocMouseTouchMove, options);
      document.addEventListener('mouseup', this.onDocMouseTouchEnd, options);
      document.addEventListener('touchend', this.onDocMouseTouchEnd, options);
      document.addEventListener('touchcancel', this.onDocMouseTouchEnd, options);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.onDocMouseTouchMove);
      document.removeEventListener('touchmove', this.onDocMouseTouchMove);
      document.removeEventListener('mouseup', this.onDocMouseTouchEnd);
      document.removeEventListener('touchend', this.onDocMouseTouchEnd);
      document.removeEventListener('touchcancel', this.onDocMouseTouchEnd);
    }
  }, {
    key: "onCropMouseTouchDown",
    value: function onCropMouseTouchDown(e) {
      var _this$props = this.props,
          crop = _this$props.crop,
          disabled = _this$props.disabled;

      if (disabled) {
        return;
      }

      e.preventDefault(); // Stop drag selection.

      var clientPos = getClientPos(e); // Focus for detecting keypress.

      this.containerRef.focus();
      var ord = e.target.dataset.ord;
      var xInversed = ord === 'nw' || ord === 'w' || ord === 'sw';
      var yInversed = ord === 'nw' || ord === 'n' || ord === 'ne';
      var cropOffset;

      if (crop.aspect) {
        cropOffset = getElementOffset(this.cropSelectRef);
      }

      this.evData = {
        clientStartX: clientPos.x,
        clientStartY: clientPos.y,
        cropStartWidth: crop.width,
        cropStartHeight: crop.height,
        cropStartX: xInversed ? crop.x + crop.width : crop.x,
        cropStartY: yInversed ? crop.y + crop.height : crop.y,
        xInversed: xInversed,
        yInversed: yInversed,
        xCrossOver: xInversed,
        yCrossOver: yInversed,
        startXCrossOver: xInversed,
        startYCrossOver: yInversed,
        isResize: e.target !== this.cropSelectRef,
        ord: ord,
        cropOffset: cropOffset
      };
      this.mouseDownOnCrop = true;
      this.setState({
        cropIsActive: true
      });
    }
  }, {
    key: "onContainerMouseTouchDown",
    value: function onContainerMouseTouchDown(e) {
      var _this$props2 = this.props,
          crop = _this$props2.crop,
          disabled = _this$props2.disabled,
          keepSelection = _this$props2.keepSelection,
          onChange = _this$props2.onChange;
      e.preventDefault(); // Stop drag selection.

      if (!compareParentNodes(e.target, this.drawSurfaceRef)) {
        return;
      }

      if (disabled || keepSelection && isCropValid(crop)) {
        return;
      }

      var clientPos = getClientPos(e); // Focus for detecting keypress.

      this.containerRef.focus();
      var imageOffset = getElementOffset(this.drawSurfaceRef);
      var xPc = (clientPos.x - imageOffset.left) / this.drawSurfaceRef.clientWidth * 100;
      var yPc = (clientPos.y - imageOffset.top) / this.drawSurfaceRef.clientHeight * 100;
      var nextCrop = {
        aspect: crop ? crop.aspect : undefined,
        x: xPc,
        y: yPc,
        width: 0,
        height: 0
      };
      this.evData = {
        clientStartX: clientPos.x,
        clientStartY: clientPos.y,
        cropStartWidth: nextCrop.width,
        cropStartHeight: nextCrop.height,
        cropStartX: nextCrop.x,
        cropStartY: nextCrop.y,
        xInversed: false,
        yInversed: false,
        xCrossOver: false,
        yCrossOver: false,
        startXCrossOver: false,
        startYCrossOver: false,
        isResize: true,
        ord: 'nw'
      };
      this.mouseDownOnCrop = true;
      onChange(nextCrop, this.getPixelCrop(nextCrop));
      this.setState({
        cropIsActive: true
      });
    }
  }, {
    key: "onDocMouseTouchMove",
    value: function onDocMouseTouchMove(e) {
      var _this$props3 = this.props,
          crop = _this$props3.crop,
          disabled = _this$props3.disabled,
          onChange = _this$props3.onChange,
          onDragStart = _this$props3.onDragStart;
      if (disabled) return;
      if (!this.mouseDownOnCrop) return;

      if (!this.isDragging) {
        this.isDragging = true;
        onDragStart();
      }

      e.preventDefault(); // Stop drag selection.

      var evData = this.evData;
      var clientPos = getClientPos(e);

      if (evData.isResize && crop.aspect && evData.cropOffset) {
        clientPos.y = this.straightenYPath(clientPos.x);
      }

      var xDiffPx = clientPos.x - evData.clientStartX;
      evData.xDiffPc = xDiffPx / this.drawSurfaceRef.clientWidth * 100;
      var yDiffPx = clientPos.y - evData.clientStartY;
      evData.yDiffPc = yDiffPx / this.drawSurfaceRef.clientHeight * 100;
      var nextCrop;

      if (evData.isResize) {
        nextCrop = this.resizeCrop();
      } else {
        nextCrop = this.dragCrop();
      }

      onChange(nextCrop, this.getPixelCrop(nextCrop));
    }
  }, {
    key: "onContainerKeyDown",
    value: function onContainerKeyDown(e) {
      var _this$props4 = this.props,
          crop = _this$props4.crop,
          disabled = _this$props4.disabled,
          onChange = _this$props4.onChange,
          onComplete = _this$props4.onComplete;

      if (disabled) {
        return;
      }

      var keyCode = e.which;
      var nudged = false;

      if (!isCropValid(crop)) {
        return;
      }

      var nextCrop = this.makeNewCrop();

      if (keyCode === arrowKey.left) {
        nextCrop.x -= nudgeStep;
        nudged = true;
      } else if (keyCode === arrowKey.right) {
        nextCrop.x += nudgeStep;
        nudged = true;
      } else if (keyCode === arrowKey.up) {
        nextCrop.y -= nudgeStep;
        nudged = true;
      } else if (keyCode === arrowKey.down) {
        nextCrop.y += nudgeStep;
        nudged = true;
      }

      if (nudged) {
        e.preventDefault(); // Stop drag selection.

        nextCrop.x = clamp(nextCrop.x, 0, 100 - nextCrop.width);
        nextCrop.y = clamp(nextCrop.y, 0, 100 - nextCrop.height);
        onChange(nextCrop, this.getPixelCrop(nextCrop));
        onComplete(nextCrop, this.getPixelCrop(nextCrop));
      }
    }
  }, {
    key: "onDocMouseTouchEnd",
    value: function onDocMouseTouchEnd() {
      var _this$props5 = this.props,
          crop = _this$props5.crop,
          disabled = _this$props5.disabled,
          onComplete = _this$props5.onComplete,
          onDragEnd = _this$props5.onDragEnd;

      if (disabled) {
        return;
      }

      if (this.isDragging) {
        onDragEnd();
        this.isDragging = false;
      }

      if (this.mouseDownOnCrop) {
        this.mouseDownOnCrop = false;
        onComplete(crop, this.getPixelCrop(crop));
        this.setState({
          cropIsActive: false
        });
      }
    }
  }, {
    key: "getPixelCrop",
    value: function getPixelCrop(crop) {
      var drawSurfaceRef = this.drawSurfaceRef;
      return {
        x: Math.round(drawSurfaceRef.clientWidth * (crop.x / 100)),
        y: Math.round(drawSurfaceRef.clientHeight * (crop.y / 100)),
        width: Math.round(drawSurfaceRef.clientWidth * (crop.width / 100)),
        height: Math.round(drawSurfaceRef.clientHeight * (crop.height / 100))
      };
    }
  }, {
    key: "getCropStyle",
    value: function getCropStyle() {
      var crop = this.props.crop;
      return {
        top: "".concat(crop.y, "%"),
        left: "".concat(crop.x, "%"),
        width: "".concat(crop.width, "%"),
        height: "".concat(crop.height, "%")
      };
    }
  }, {
    key: "getNewSize",
    value: function getNewSize() {
      var _this$props6 = this.props,
          crop = _this$props6.crop,
          minWidth = _this$props6.minWidth,
          maxWidth = _this$props6.maxWidth,
          minHeight = _this$props6.minHeight,
          maxHeight = _this$props6.maxHeight;
      var evData = this.evData;
      var drawSurfaceAspect = this.drawSurfaceRef.clientWidth / this.drawSurfaceRef.clientHeight; // New width.

      var newWidth = evData.cropStartWidth + evData.xDiffPc;

      if (evData.xCrossOver) {
        newWidth = Math.abs(newWidth);
      }

      newWidth = clamp(newWidth, minWidth, maxWidth); // New height.

      var newHeight;

      if (crop.aspect) {
        newHeight = newWidth / crop.aspect * drawSurfaceAspect;
      } else {
        newHeight = evData.cropStartHeight + evData.yDiffPc;
      }

      if (evData.yCrossOver) {
        // Cap if polarity is inversed and the height fills the y space.
        newHeight = Math.min(Math.abs(newHeight), evData.cropStartY);
      }

      newHeight = clamp(newHeight, minHeight, maxHeight);

      if (crop.aspect) {
        newWidth = clamp(newHeight * crop.aspect / drawSurfaceAspect, 0, 100);
      }

      return {
        width: newWidth,
        height: newHeight
      };
    }
  }, {
    key: "dragCrop",
    value: function dragCrop() {
      var nextCrop = this.makeNewCrop();
      var evData = this.evData;
      nextCrop.x = clamp(evData.cropStartX + evData.xDiffPc, 0, 100 - nextCrop.width);
      nextCrop.y = clamp(evData.cropStartY + evData.yDiffPc, 0, 100 - nextCrop.height);
      return nextCrop;
    }
  }, {
    key: "resizeCrop",
    value: function resizeCrop() {
      var nextCrop = this.makeNewCrop();
      var evData = this.evData;
      var ord = evData.ord;
      var drawSurfaceAspect = this.drawSurfaceRef.clientWidth / this.drawSurfaceRef.clientHeight; // On the inverse change the diff so it's the same and
      // the same algo applies.

      if (evData.xInversed) {
        evData.xDiffPc -= evData.cropStartWidth * 2;
      }

      if (evData.yInversed) {
        evData.yDiffPc -= evData.cropStartHeight * 2;
      } // New size.


      var newSize = this.getNewSize(); // Adjust x/y to give illusion of 'staticness' as width/height is increased
      // when polarity is inversed.

      var newX = evData.cropStartX;
      var newY = evData.cropStartY;

      if (evData.xCrossOver) {
        newX = nextCrop.x + (nextCrop.width - newSize.width);
      }

      if (evData.yCrossOver) {
        // This not only removes the little 'shake' when inverting at a diagonal, but for some
        // reason y was way off at fast speeds moving sw->ne with fixed aspect only, I couldn't
        // figure out why.
        if (evData.lastYCrossover === false) {
          newY = nextCrop.y - newSize.height;
        } else {
          newY = nextCrop.y + (nextCrop.height - newSize.height);
        }
      }

      var containedCrop = containCrop({
        x: newX,
        y: newY,
        width: newSize.width,
        height: newSize.height,
        aspect: nextCrop.aspect
      }, drawSurfaceAspect); // Apply x/y/width/height changes depending on ordinate (fixed aspect always applies both).

      if (nextCrop.aspect || _indexOfInstanceProperty(xyOrds).call(xyOrds, ord) > -1) {
        nextCrop.x = containedCrop.x;
        nextCrop.y = containedCrop.y;
        nextCrop.width = containedCrop.width;
        nextCrop.height = containedCrop.height;
      } else if (_indexOfInstanceProperty(xOrds).call(xOrds, ord) > -1) {
        nextCrop.x = containedCrop.x;
        nextCrop.width = containedCrop.width;
      } else if (_indexOfInstanceProperty(yOrds).call(yOrds, ord) > -1) {
        nextCrop.y = containedCrop.y;
        nextCrop.height = containedCrop.height;
      }

      evData.lastYCrossover = evData.yCrossOver;
      this.crossOverCheck();
      return nextCrop;
    }
  }, {
    key: "straightenYPath",
    value: function straightenYPath(clientX) {
      var evData = this.evData;
      var ord = evData.ord;
      var cropOffset = evData.cropOffset;
      var cropStartWidth = evData.cropStartWidth / 100 * this.drawSurfaceRef.clientWidth;
      var cropStartHeight = evData.cropStartHeight / 100 * this.drawSurfaceRef.clientHeight;
      var k;
      var d;

      if (ord === 'nw' || ord === 'se') {
        k = cropStartHeight / cropStartWidth;
        d = cropOffset.top - cropOffset.left * k;
      } else {
        k = -cropStartHeight / cropStartWidth;
        d = cropOffset.top + (cropStartHeight - cropOffset.left * k);
      }

      return k * clientX + d;
    }
  }, {
    key: "setCropSelectRef",
    value: function setCropSelectRef(ref) {
      this.cropSelectRef = ref;
    }
  }, {
    key: "createCropSelection",
    value: function createCropSelection() {
      var _this$props7 = this.props,
          s = _this$props7.styles,
          crop = _this$props7.crop,
          disabled = _this$props7.disabled;
      var style = this.getCropStyle();
      var fixedAspect = crop && crop.aspect;
      return /*#__PURE__*/React.createElement("div", _extends({}, s('cropSelection'), {
        ref: this.setCropSelectRef,
        style: style,
        onMouseDown: this.onCropMouseTouchDown,
        onTouchStart: this.onCropMouseTouchDown
      }), !disabled && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", _extends({}, s('dragBar', 'ordNBar', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "n"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragBar', 'ordEBar', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "e"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragBar', 'ordSBar', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "s"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragBar', 'ordWBar', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "w"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordNW'), {
        "data-ord": "nw"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordN', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "n"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordNE'), {
        "data-ord": "ne"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordE', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "e"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordSE'), {
        "data-ord": "se"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordS', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "s"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordSW'), {
        "data-ord": "sw"
      })), /*#__PURE__*/React.createElement("div", _extends({}, s('dragHandle', 'ordW', {
        fixedAspect: fixedAspect
      }), {
        "data-ord": "w"
      }))));
    }
  }, {
    key: "makeNewCrop",
    value: function makeNewCrop() {
      return _objectSpread(_objectSpread({}, defaultCrop), this.props.crop);
    }
  }, {
    key: "crossOverCheck",
    value: function crossOverCheck() {
      var evData = this.evData;

      if (!evData.xCrossOver && -Math.abs(evData.cropStartWidth) - evData.xDiffPc >= 0 || evData.xCrossOver && -Math.abs(evData.cropStartWidth) - evData.xDiffPc <= 0) {
        evData.xCrossOver = !evData.xCrossOver;
      }

      if (!evData.yCrossOver && -Math.abs(evData.cropStartHeight) - evData.yDiffPc >= 0 || evData.yCrossOver && -Math.abs(evData.cropStartHeight) - evData.yDiffPc <= 0) {
        evData.yCrossOver = !evData.yCrossOver;
      }

      var swapXOrd = evData.xCrossOver !== evData.startXCrossOver;
      var swapYOrd = evData.yCrossOver !== evData.startYCrossOver;
      evData.inversedXOrd = swapXOrd ? inverseOrd(evData.ord) : false;
      evData.inversedYOrd = swapYOrd ? inverseOrd(evData.ord) : false;
    }
  }, {
    key: "setContainerRef",
    value: function setContainerRef(ref) {
      this.containerRef = ref;
    }
  }, {
    key: "setDrawSurfaceRef",
    value: function setDrawSurfaceRef(ref) {
      this.drawSurfaceRef = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          s = _this$props8.styles,
          children = _this$props8.children,
          crop = _this$props8.crop,
          disabled = _this$props8.disabled;
      var cropIsActive = this.state.cropIsActive;
      var cropSelection = isCropValid(crop) ? this.createCropSelection() : null;
      return /*#__PURE__*/React.createElement("div", _extends({}, s('container', {
        disabled: disabled
      }), {
        ref: this.setContainerRef,
        onTouchStart: this.onContainerMouseTouchDown,
        onMouseDown: this.onContainerMouseTouchDown,
        onKeyDown: this.onContainerKeyDown,
        tabIndex: "1"
      }), /*#__PURE__*/React.createElement("div", _extends({}, s('drawSurface', {
        invisible: cropIsActive && crop && (!crop.width || !crop.height)
      }), {
        ref: this.setDrawSurfaceRef
      }), React.Children.only(children)), cropSelection);
    }
  }]);

  return CropSelector;
}(PureComponent), _defineProperty(_class2, "propTypes", {
  crop: PropTypes.shape({
    aspect: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  }),
  disabled: PropTypes.bool,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  keepSelection: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
}), _defineProperty(_class2, "defaultProps", {
  disabled: false,
  maxWidth: 100,
  maxHeight: 100,
  minWidth: 0,
  minHeight: 0,
  keepSelection: false,
  onComplete: function onComplete() {},
  onDragStart: function onDragStart() {},
  onDragEnd: function onDragEnd() {}
}), _temp)) || _class) || _class);
export default CropSelector;